// VideoPopup.js
import React, {  useState} from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SubmitTroubleForm from '../../apis/troubleForm/troubleForm';

const VideoPopup = ({ isOpen, onClose}) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [description, setDescription] = useState('');
  const [successMessage, setSuccessMessage] = useState(""); 
  const [errors, setErrors] = useState({});

  // Validation function
  const validateForm = () => {
    const newErrors = {};
    if (!firstName) newErrors.firstName = 'First Name is required';
    if (!lastName) newErrors.lastName = 'Last Name is required';
    if (!email) newErrors.email = 'Email Address is required';
    if (!phone) newErrors.phone = 'Phone Number is required';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    setSuccessMessage("Form submitted successfully!");
    e.preventDefault();
    if (!validateForm()) {
      return;
  }

    const selectedCategories = Array.from(document.querySelectorAll('.checkbox-content input[type="checkbox"]:checked'))
        .map(checkbox => checkbox.value)
        .join(',');
    const formData = {
        firstname: firstName,
        lastname: lastName,
        email: email,
        phone: phone,
        category: selectedCategories, 
        description: description,
    };

    try {
        const response = await SubmitTroubleForm( formData);
        setSuccessMessage("Form submitted successfully!");
         resetForm();
         setTimeout(() => {
          onClose();
          setSuccessMessage(""); // Clear success message
        }, 500);
      } catch (error) {
        alert('Failed to submit the form.');
    }
};

  
  const resetForm = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setPhone('');
    setDescription('');
    setErrors({}); 
  };

  const handleClose = () => {
    resetForm(); 
    setSuccessMessage(""); 
    onClose(); 
  };
  if (!isOpen) return null;

  return (
    <>
      <div className="popup-fixed"></div>
      <div className="popup-container popup-container-fixed" data-aos="fade-down" data-aos-easing="linear">
        <div className="video-popup">
          <div className="container" data-aos="fade-down" data-aos-easing="linear">
            <div className="row">
              <div className="col-md-8 m-auto shadow" style={{ backgroundColor: '#fff', borderRadius: "0 0 15px 15px" }}>
                <div className="relative">
                  <span className="close-popup" onClick={handleClose}></span>
                  <div className="col-md-12">
                    <div >
                      <div className="video-container">
                        <div id='trouble' className="popUP">
                        <form onSubmit={handleSubmit}>
                        {successMessage && (
                              <div className="success-message" style={{ color: "green", marginBottom: "10px", textAlign:'center' }}>
                                {successMessage}
                              </div>
                            )}
                            <h3>Having trouble? Don't worry, we're here to help.</h3> 
                            <ul className="checkbox-content">
                              <li><input className="" name="" type="checkbox" value="Card Tap Not Working" id="CardTap" /> <label htmlFor="CardTap" className="">Card Tap Not Working</label></li>
                              <li><input className="" name="" type="checkbox" value="Album Not Visible" id="AlbumNot" /> <label htmlFor="AlbumNot" className="">Album Not Visible</label></li>
                              <li><input className="" name="" type="checkbox" value="Showing No Value" id="ShowingNo" /> <label htmlFor="ShowingNo" className="">Showing No Value</label></li>
                              <li><input className="" name="" type="checkbox" value="Issue With Track" id="IssueWith" /> <label htmlFor="IssueWith" className="">Issue With Track</label></li>
                            </ul>
                            <p className="a-call">Book a call with a Community Musician expert now.</p>
                            <ul className="form-ul">
                              <li className="li-one">
                                <label>First Name <i>*</i></label>
                                <input 
                                  type="text" 
                                  className="input-text" 
                                  value={firstName}
                                  onChange={(e) => setFirstName(e.target.value)} 
                                />
                                {errors.firstName && <span className="error">{errors.firstName}</span>}
                              </li>
                              <li className="li-one">
                                <label>Last Name <i>*</i></label>
                                <input 
                                  type="text" 
                                  className="input-text" 
                                  value={lastName}
                                  onChange={(e) => setLastName(e.target.value)} 
                                />
                                {errors.lastName && <span className="error">{errors.lastName}</span>}
                              </li>
                              <li className="li-one">
                                <label>Email Address <i>*</i></label>
                                <input 
                                  type="text" 
                                  className="input-text" 
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)} 
                                />
                                {errors.email && <span className="error">{errors.email}</span>}
                              </li>
                              <li className="li-one">
                                <label>Phone Number <i>*</i></label>
                                <input 
                                  type="number" 
                                  className="input-text" 
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)} 
                                />
                                {errors.phone && <span className="error">{errors.phone}</span>}
                              </li>
                              <li className="li-two">
                                <label>Description </label>
                                <textarea 
                                  rows="" 
                                  cols="" 
                                  className="input-text"
                                  value={description}
                                  onChange={(e) => setDescription(e.target.value)} 
                                />
                                
                              </li>
                              <li className="li-two">
                                <input type="submit" className="button" value="Submit" />
                              </li>
                            </ul>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default VideoPopup;
